import {PostCard} from '../PostCard/index';
import './styles.css'
export const Posts = ({posts}) => ( 
  <div className="posts">
  {posts.map(post => (
    <PostCard
    key = {post.id}
    title = {post.title} //também daria pra passar o objeto em si (post), porem ele passaria o objeto do objeto
    body = {post.body}
    id = {post.id}
    cover = {post.cover}
    /> //Nosso post não tem filhos então não precisa fechar a tag </> somente os atributos
  ))} 
</div>
);